import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardShell from "@/components/DashboardShell";
import StatsOverview from "@/components/StatsOverview";
import ParticipantsPanel from "@/components/ParticipantsPanel";
import AdminUsers from "@/components/AdminUsers";
import SiteManager from "@/components/SiteManager";
import CampusManager from "@/components/CampusManager";
import DisbursementManager from "@/components/DisbursementManager";
import ActiveLetterApprovalManager from "@/components/ActiveLetterApprovalManager";
import SelectionImportManager from "@/components/SelectionImportManager";
import AiAdministrativeVerification from "@/components/AiAdministrativeVerification";
import ApplicantArchiveManager from "@/components/ApplicantArchiveManager";
import AdminRecipientDashboard from "@/components/AdminRecipientDashboard";
import LiveChat from "@/components/LiveChat";
import SelectionAnnouncementManager from "@/components/SelectionAnnouncementManager";
import InterviewFormManager from "@/components/InterviewFormManager";
import InterviewScoresManager from "@/components/InterviewScoresManager";
import {
  BarChart3,
  BellRing,
  Building2,
  FileSpreadsheet,
  FileCheck2,
  HandCoins,
  Users,
  ShieldCheck,
  LayoutDashboard,
  Sparkles,
  Archive,
  MessageCircleMore,
  PanelTop,
  ClipboardList,
  ClipboardCheck,
} from "lucide-react";

const MENU = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { id: "ringkasan", label: "Ringkasan", icon: BarChart3 },
  { id: "peserta", label: "Data Peserta", icon: Users },
  { id: "import-seleksi", label: "Import Seleksi", icon: FileSpreadsheet },
  { id: "verifikasi-ai", label: "Verifikasi AI", icon: Sparkles },
  { id: "surat-aktif", label: "Surat Aktif AI", icon: FileCheck2 },
  { id: "pengumuman-seleksi", label: "Pengumuman Seleksi", icon: BellRing },
  { id: "pencairan-dana", label: "Pencairan Dana", icon: HandCoins },
  { id: "portal-pencairan", label: "Portal Pencairan", icon: PanelTop },
  { id: "kampus", label: "Kampus", icon: Building2 },
  { id: "admin", label: "Admin Wilayah", icon: ShieldCheck },
  { id: "form-wawancara", label: "Form Wawancara", icon: ClipboardList },
  { id: "hasil-wawancara", label: "Hasil Wawancara", icon: ClipboardCheck },
  { id: "live-chat", label: "Live Chat", icon: MessageCircleMore },
  { id: "arsip-pendaftar", label: "Arsip Pendaftar", icon: Archive },
  { id: "website", label: "Kelola Website", icon: LayoutDashboard },
];

export default function SuperAdminDashboard() {
  const navigate = useNavigate();
  const [active, setActive] = useState("dashboard");
  const [participantRegion, setParticipantRegion] = useState("all");
  const openFilteredParticipants = (region) => {
    setParticipantRegion(region);
    setActive("peserta");
  };
  const handleSelect = (itemId) => {
    if (itemId === "portal-pencairan") {
      navigate("/portal-pencairan-tahap-ii");
      return;
    }
    setActive(itemId);
  };

  return (
    <DashboardShell menu={MENU} active={active} onSelect={handleSelect} brandLabel="Super Admin"
      title={MENU.find((m) => m.id === active)?.label}
      subtitle="Panel kendali MDJ Scholarship • Tahun 2026">
      {active === "dashboard" && (
        <AdminRecipientDashboard onViewParticipants={openFilteredParticipants} />
      )}
      {active === "ringkasan" && <StatsOverview showAdmins />}
      {active === "peserta" && <ParticipantsPanel initialRegion={participantRegion} />}
      {active === "pencairan-dana" && <DisbursementManager />}
      {active === "admin" && <AdminUsers canManageProvincial />}
      {active === "form-wawancara" && <InterviewFormManager />}
      {active === "hasil-wawancara" && <InterviewScoresManager />}
      {active === "verifikasi-ai" && <AiAdministrativeVerification />}
      {active === "import-seleksi" && <SelectionImportManager />}
      {active === "kampus" && <CampusManager />}
      {active === "surat-aktif" && <ActiveLetterApprovalManager />}
      {active === "live-chat" && <LiveChat />}
      {active === "pengumuman-seleksi" && <SelectionAnnouncementManager />}
      {active === "arsip-pendaftar" && <ApplicantArchiveManager />}
      {active === "website" && <SiteManager />}
    </DashboardShell>
  );
}
